var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadedit"},[(_vm.loading)?_c('BlockUI',{attrs:{"message":"","html":_vm.html}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }